import { Box, Container } from "@mui/material";
import { Link, Outlet } from "react-router-dom";
import logo from "../../assets/images/logo/login_logo.png";

const AuthLayout = () => {
  return (
    <Container sx={{ maxWidth: "420px !important" }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        {/* Logo */}
        <Box component={Link} to="/" sx={{ py: 2 }}>
          <img src={logo} alt="Logo" />
        </Box>
        <Outlet />
      </Box>
    </Container>
  );
};

export default AuthLayout;
